var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
export function ThemeProvider(_a) {
    var children = _a.children;
    return _jsx(MuiThemeProvider, __assign({ theme: theme }, { children: children }));
}
